"use client"

import { AboutUsSectionProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const AboutUsSection = {
  label: "Tamda OC | About Us Section",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    description: {
      label: "Description",
      type: "textarea",
    },
    floorPlanImage: {
      label: "Floor Plan Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    logo: {
      label: "Logo",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    mainImage: {
      label: "Main Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "VỀ CHÚNG TÔI",
    description:
      "Tamda Obchodní Centrum là một tổ hợp mua sắm đa chức năng tọa lạc tại Všebořice, khu vực Ústecký, Cộng hòa Séc. Tổng diện tích là 80.000m² và diện tích kinh doanh là 25.000m², đây là một trong những trung tâm mua sắm lớn nhất và hoàn chỉnh nhất trong khu vực.",
    floorPlanImage: "",
    logo: "",
    mainImage: "",
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
} as ComponentConfig<AboutUsSectionProps>
